// extracted by mini-css-extract-plugin
export default {"pg":"PageNotFound_pg__8uXo9","error":"PageNotFound_error__8QfV5","btohome":"PageNotFound_btohome__Ka2dp"};